import { useEffect, useMemo, useState } from "react";
import {
  List,
  TextField,
  WrapperField,
  DatagridConfigurable,
  WithRecord,
  DateField,
  NumberField,
  BooleanField,
  BulkDeleteWithConfirmButton,
  useResourceContext,
  useTheme,
  usePermissions,
  FunctionField,
  RecordContextProvider,
} from "react-admin";
import PurchaseReturnAddDialog from "../../components/purchaseReturns/create/PurchaseReturnAddDialog";
import PurchaseReturnEditDialog from "../../components/purchaseReturns/edit/PurchaseReturnEditDialog";
import purchaseReturnFilterList from "../../components/purchaseReturns/filter/purchaseReturnFilterList";
import TableListActions from "../../components/tableListActions/TableListActions";
import PurchaseReturnExpandList from "../../components/purchaseReturns/expand/PurchaseReturnExpandList";
import EditBtn from "../../components/editBtn/EditBtn";
import ConfirmBtn from "../../components/confirmBtn/ConfirmBtn";
import DoneIcon from "@mui/icons-material/Done";
import PrintHandler from "../../components/printHandler/PrintHandler";
import PrintBtn from "../../components/printBtn/PrintBtn";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import PurchaseAsideList from "../../components/purchases/aside/PurchaseAsideList";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import PrintContent from "../../components/purchaseReturns/print/PrintContent";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const PurchaseReturnList = () => {
  const resource = useResourceContext();
  const { permissions } = usePermissions();
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [recordId, setRecordId] = useState();
  const [showAside, setShowAside] = useState(false);
  const [resetPrintContent, setResetPrintContent] = useState();
  const [printRecord, setPrintRecord] = useState({}); // initial value wajib object kosong untuk cek key id di dependency useeffect DeliveryNote.js
  const [theme] = useTheme("light");

  useEffect(() => {
    setShowAside(resource === "purchase-return-cards");
  }, [resource]);

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const handleClickOpenEdit = (recId) => () => {
    setRecordId(recId);
    setOpenEdit(true);
  };
  const rowClickHandler = (id, basePath, record) => {
    setShowAside((prev) => !prev);
  };

  const forReport = resource === "purchase-return-cards";

  const list = useMemo(() => {
    let actions = (
      <TableListActions
        createHandler={handleClickOpenAdd}
        filter={false}
        exporter={false}
        createPermission="create_purchase_return"
      />
    );

    let filterDefaultValues = {
      start_date: firstDate,
      end_date: lastDate,
    };

    let bulkActionButtons = <BulkDeleteWithConfirmButton />;

    let boolAct = [
      <BooleanField
        key={1}
        source="approved"
        label="mine.label.approved"
        textAlign="center"
      />,
      <WrapperField key={2} label="mine.label.actions" textAlign="center">
        <WithRecord
          // label="author"
          render={(record) => {
            return !record.approved ? (
              <>
                <EditBtn
                  editHandler={handleClickOpenEdit(record.id)}
                  sx={{ mr: 1 }}
                />
                <ConfirmBtn
                  title="mine.message.approve"
                  content="mine.message.approve_content"
                  label="mine.btn.approve"
                  resource={resource + "/approve"}
                  startIcon={<DoneIcon />}
                />
              </>
            ) : (
              <PrintBtn
                dialogProps={{ title: "mine.dialog.print" }}
                recordId={record.id}
                setPrintRecord={setPrintRecord}
                setResetPrintContent={setResetPrintContent}
              />
            );
          }}
        />
      </WrapperField>,
    ];

    if (forReport) {
      actions = <DownloadAction />;
      filterDefaultValues.approved = 1;
      bulkActionButtons = false;
      boolAct = null;
    }

    return (
      <List
        title="mine.list_title.purchase_return"
        empty={false}
        aside={showAside || forReport ? <PurchaseAsideList /> : null}
        actions={actions}
        filters={purchaseReturnFilterList(permissions)}
        filterDefaultValues={filterDefaultValues}
        queryOptions={{ meta: { sort: ["created_at DESC"] } }} // overide default sort
        sx={{
          flexDirection: "column",
        }}
      >
        <DatagridConfigurable
          bulkActionButtons={bulkActionButtons}
          rowClick={rowClickHandler}
          expand={<PurchaseReturnExpandList forReport={forReport} />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          <TextField label="mine.label.depo" source="company.alias" />
          <TextField source="code" label="mine.label.receipt_no" />
          <DateField
            source="date"
            label="mine.label.date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <TextField label="mine.label.supplier" source="supplier.name" />
          <FunctionField
            textAlign="right"
            label="Box"
            render={(record) => {
              let rec = { total_return: 0 };
              for (let i = 0; i < record.purchase_return_items.length; i++) {
                rec.total_return +=
                  +record.purchase_return_items[i].return_quantity;
              }
              return (
                <RecordContextProvider value={rec}>
                  <NumberField source="total_return" />
                </RecordContextProvider>
              );
            }}
          />
          <NumberField source="total" />
          <TextField source="note" label="mine.label.note" emptyText="-" />
          {boolAct}
        </DatagridConfigurable>
      </List>
    );
  }, [showAside, forReport, theme, permissions]);
  return (
    <>
      {list}
      {!forReport && (
        <>
          <PurchaseReturnAddDialog open={openAdd} setOpen={setOpenAdd} />
          <PurchaseReturnEditDialog
            open={openEdit}
            setOpen={setOpenEdit}
            recordId={recordId}
          />
          <PrintHandler
            record={printRecord}
            resetPrintContent={resetPrintContent}
            Content={PrintContent} //{PurchaseReturnPrint}
          />
        </>
      )}
    </>
  );
};

export default PurchaseReturnList;
